export const unkownErrorInterceptor = {
  onFulFilled: (config) => config,
  onError: (error) => {
    if (error.code === 'ERR_BAD_REQUEST') {
      if (error.response?.data?.RedirectToHomePage) {
        window.location.href = `${window.SUB_DOMAIN}/Discovery/Manage`;
        return new Promise(() => {});
      }
    }
    if (error.code && error.code === 'ERR_NETWORK') {
      console.log('sso cors');
      console.log(error);
      console.log('sso cors');
      const newError = {
        response: {
          data: { ...error, Message: error.message },
        },
      };
      return Promise.reject(newError);
    }

    return Promise.reject(error);
  },
};
